/**
 * Protected Route Component
 * Redirects to login if not authenticated
 * Supports role-based access control
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const OPERATIONAL_ROLES = ['ADMIN', 'HR', 'HRO'];

const canChairmanAccessOperationalRoute = (role, allowedRoles) => {
  if (role !== 'CHAIRMAN') {
    return false;
  }

  return allowedRoles.some((allowedRole) => OPERATIONAL_ROLES.includes(allowedRole));
};

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check role-based access if allowedRoles is specified
  if (
    allowedRoles.length > 0
    && !allowedRoles.includes(user?.role)
    && !canChairmanAccessOperationalRoute(user?.role, allowedRoles)
  ) {
    // Redirect to user's appropriate dashboard
    switch (user?.role) {
      case 'CANDIDATE':
        return <Navigate to="/candidate/dashboard" replace />;
      case 'HR':
        return <Navigate to="/hr/dashboard" replace />;
      case 'ADMIN':
        return <Navigate to="/admin/dashboard" replace />;
      case 'CHAIRMAN':
        return <Navigate to="/chairman/dashboard" replace />;
      default:
        return <Navigate to="/login" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
